import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;

const ContactsService = {
    institutions: async (payload) => axios.post(API_URL + "/sharedInstitutions/list", payload).then(({ data }) => data).catch((err) => { throw err}),

    institutionsIbge: (ibge) => `${BASENAME}shared-institutions?ibge=${ibge}`,
    
    agents: async (payload) => axios.post(API_URL + "/sharedAgents/list", payload).then(({ data }) => data).catch((err) => { throw err}),
    
    agentsIbge: (ibge) => `${BASENAME}shared-agents?ibge=${ibge}`,

    contacts: async () => axios.get(API_URL + "/contacts/data").then(({ data }) => data).catch((err) => { throw err}),
};

export default ContactsService;